import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Setzt die Scroll-Position bei jedem Seitenwechsel zurück an den Seitenanfang.
 * Ohne das behält der Browser bei einer Client-seitigen Navigation den bisherigen
 * Offset bei – man landet dann mitten in der neuen Seite.
 *
 * Bei Zurück/Vorwärts (POP) bleibt die Position erhalten, damit die
 * Scroll-Wiederherstellung des Browsers weiterhin greift.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
